import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { SidebarGlobalSettingsSystem as GlobalSystemSettingsSidebarType } from './ui/index.tsx';

const LazyGlobalSystemSettingsSidebar = lazyAfterPaint<typeof GlobalSystemSettingsSidebarType>(
	() => {
		setPerformanceMarkLoadStart();
		return import(/* webpackChunkName: "async-sidebar-global-settings-system" */ './index').then(
			(bundle) => {
				setPerformanceMarkLoadEnd();
				return bundle;
			},
		);
	},
	{ entryFsSsrLiftImportToModule: false },
);

const GlobalSystemSettingsSidebar = memo(() => (
	<SidebarBoundary id="globalSystemSettings">
		<LazyGlobalSystemSettingsSidebar />
	</SidebarBoundary>
));

GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';

export default GlobalSystemSettingsSidebar;
